import React from "react";
import { useSelector } from "react-redux";
import LandingHeader from "../components/landing/LandingHeader";
import LandingFooter from "../components/landing/LandingFooter";

const ContactUs = () => {
  const translation = useSelector((state) => state.translation);

  return (
    <div className="contact-page">
      <LandingHeader />
      <main className="privacy-main contact-main">
        <div className="contact-hero-wrap">
          <div className="privacy-container contact-container">
            <div className="contact-hero">
              <h1>{translation.contact_title || "Contact Us"}</h1>
              <p>
                {translation.contact_hero_copy ||
                  "We'd love to hear from you. Whether you have a question about esyncing, need support, or want to explore how our platform fits your organization, our team is here to help."}
              </p>
            </div>
          </div>
        </div>

        <div className="privacy-container contact-container">
          <div className="contact-grid">
            <div className="contact-info">
              <h2>{translation.contact_info_title || "Contact Information"}</h2>
              <div className="contact-item">
                <h4>{translation.contact_general_inquiries || "General Inquiries"}</h4>
                <a href="mailto:hello@esyncing.com">hello@esyncing.com</a>
              </div>
              <div className="contact-item">
                <h4>{translation.contact_support || "Support"}</h4>
                <a href="mailto:support@esyncing.com">support@esyncing.com</a>
              </div>
              <div className="contact-item">
                <h4>{translation.contact_legal || "Legal"}</h4>
                <a href="mailto:legal@esyncing.com">legal@esyncing.com</a>
              </div>
              <div className="contact-item">
                <h4>{translation.contact_office || "Office"}</h4>
                <p>{translation.contact_office_name || "esyncing"}</p>
              </div>
              <div className="contact-note">
                <h4>{translation.contact_response_time || "Response Time"}</h4>
                <p>{translation.contact_response_copy || "We aim to respond to all inquiries within 1-2 business days."}</p>
              </div>
            </div>
            <div className="contact-form-card">
              <h2>{translation.contact_form_title || "Send Us a Message"}</h2>
              <p>{translation.contact_form_subtitle || "Please fill out the form below and we'll get back to you as soon as possible."}</p>
              <form className="contact-form">
                <label>
                  {translation.contact_full_name_label || "Full Name *"}
                  <input
                    type="text"
                    placeholder={translation.contact_full_name_placeholder || "Enter your full name"}
                  />
                </label>
                <label>
                  {translation.contact_work_email_label || "Work Email *"}
                  <input
                    type="email"
                    placeholder={translation.contact_work_email_placeholder || "your.email@company.com"}
                  />
                </label>
                <label>
                  {translation.contact_company_label || "Company (optional)"}
                  <input
                    type="text"
                    placeholder={translation.contact_company_placeholder || "Your company name"}
                  />
                </label>
                <label>
                  {translation.contact_message_label || "Message *"}
                  <textarea
                    placeholder={translation.contact_message_placeholder || "Tell us how we can help..."}
                    rows={4}
                  />
                </label>
                <div className="contact-disclaimer">
                  {translation.contact_disclaimer ||
                    "By submitting this form, you agree that your information will be used only to respond to your inquiry in accordance with our Privacy Policy."}
                </div>
                <button type="submit" className="landing-btn landing-btn-primary contact-submit">
                  {translation.contact_submit || "Send Message"}
                </button>
              </form>
            </div>
          </div>

          <div className="contact-footer-note">
            {translation.contact_footer_note || "Thank you for reaching out to esyncing."}
          </div>
        </div>
      </main>
      <LandingFooter />
    </div>
  );
};

export default ContactUs;
